import Vue from 'vue'

Vue.mixin({
  data() {
    return {
      rowActions: []
    }
  },
  methods: {
    anyDataChecked(data) {
      if (data) {
        for (const key in data) {
          if (data[key]) {
            return true
          }
        }
      }
      return false
    },
    allDataChecked(data) {
      if (data) {
        for (const key in data) {
          if (!data[key]) {
            return false
          }
        }
        return true
      }
      return false
    },
    getDeviceId() {
      if (!window) {
        console.log('[Lineus] No window')
      } else if (!window.getDeviceInfo) {
        console.log('[Lineus] No window.getDeviceInfo')
      } else if (!this.loggedInUser) {
        console.log('[Lineus] Not logged in yet')
      } else {
        const did = window.getDeviceInfo.getDeviceId(this.loggedInUser.id)
        console.log('[Lineus] Device ID : ' + did)
        return did
      }
    },
    openURL(url, target) {
      if (url) {
        if (!target) {
          if (url.startsWith('http:') || url.startsWith('https:')) {
            target = '_blank'
          } else {
            target = '_self'
          }
        }
        window.open(url, target)
      }
    },
    async validateUnder(elem, scrollElem, onBeginCb, onSuccessCb, onFailCb) {
      if (onBeginCb) {
        onBeginCb()
      }
      let invalidInputControlName
      const inputControlNames = []
      $(elem)
        .find('[input-control-name]')
        .each(function() {
          if (!$(this).attr('readonly') && !$(this).attr('disabled')) {
            inputControlNames.push($(this).attr('input-control-name'))
          }
        })
      for (let i = 0; i < inputControlNames.length; i++) {
        if (!(await this.$validator.validate(inputControlNames[i]))) {
          invalidInputControlName =
            '[input-control-name="' + inputControlNames[i] + '"]'
          break
        }
      }
      if (invalidInputControlName) {
        if (onFailCb) {
          onFailCb(invalidInputControlName)
        }
        this.$nextTick(() => {
          let relative = 0
          if (!scrollElem) {
            scrollElem = 'html'
          } else {
            relative = $(scrollElem).scrollTop() + $(scrollElem).offset().top
          }
          $(scrollElem).animate(
            {
              scrollTop:
                $(invalidInputControlName).offset().top + relative - 150
            },
            400,
            'swing',
            () => {
              $(invalidInputControlName).animate(
                {
                  opacity: 0.4
                },
                200,
                'swing',
                () => {
                  $(invalidInputControlName).animate(
                    {
                      opacity: 1
                    },
                    200,
                    'swing'
                  )
                }
              )
            }
          )
          this.$toast.error(
            $(invalidInputControlName)
              .find('.show-invalid')
              .first()
              .text()
          )
          $(invalidInputControlName)
            .find('input[type!=hidden]')
            .focus()
        })
      } else if (onSuccessCb) {
        onSuccessCb()
      }
      return invalidInputControlName === undefined
    },
    async openMenuPathWithAditFieldData(keyString, value, obj) {
      const url = await this.getMenuPathWithAditFieldData(keyString, value, obj)
      if (!url) {
        this.$toast.error(this.$t('page.error.not_found'))
        return
      }
      window.open(url)
    },
    async getMenuPathWithAditFieldData(keyString, value, obj) {
      const res = await this.$axios.$get(
        '/menu/public/getMenuPathWithAditFieldData?keyString=' +
          encodeURIComponent(keyString) +
          '&value=' +
          encodeURIComponent(value),
        {
          no_loading: true
        }
      )
      if (obj && res.data) {
        obj.menuPath = res.data
      }
      return res.data
    },
    getPrefix(inputControl, object) {
      let prefix = ''
      if (
        inputControl &&
        inputControl.valueSource &&
        inputControl.valueSource.prefixes
      ) {
        for (let i = 0; i < inputControl.valueSource.prefixes.length; i++) {
          const prefixValueSource = inputControl.valueSource.prefixes[i]
          prefix += this.getValueSourceValue(prefixValueSource, object)
        }
      }
      return prefix
    },
    getPostfix(inputControl, object) {
      let postfix = ''
      if (
        inputControl &&
        inputControl.valueSource &&
        inputControl.valueSource.postfixes
      ) {
        for (let i = 0; i < inputControl.valueSource.postfixes.length; i++) {
          const postfixValueSource = inputControl.valueSource.postfixes[i]
          postfix += this.getValueSourceValue(postfixValueSource, object)
        }
      }
      return postfix
    },
    getWithFields(inputControl) {
      const fields = []
      for (const key in inputControl.rules) {
        if (
          inputControl.rules[key].withFields &&
          inputControl.rules[key].withFields.length > 0
        ) {
          for (let i = 0; i < inputControl.rules[key].withFields.length; i++) {
            if (inputControl.rules[key].withFields[i].fieldName) {
              fields.push(inputControl.rules[key].withFields[i].fieldName)
            } else if (inputControl.rules[key].withFields[i].value) {
              fields.push(inputControl.rules[key].withFields[i].value)
            }
          }
        }
      }
      return fields
    },
    getValueSourceValue(valueSource, object) {
      const type = valueSource.type
      let value = ''
      if (valueSource.prefixes && valueSource.prefixes.length > 0) {
        for (let i = 0; i < valueSource.prefixes.length; i++) {
          value += this.getValueSourceValue(valueSource.prefixes[i], object)
        }
      }
      switch (type) {
        case 'static_value':
          value += valueSource.staticValue
          break
        case 'other_column':
          const keys = valueSource.fieldName.split('.')
          let val = window.copyObject(object)

          for (let j = 0; j < keys.length; j++) {
            val = val[keys[j]]
            if (val === undefined || val === null) {
              return ''
            }
          }
          value += val
          break
      }
      if (valueSource.postfixes && valueSource.postfixes.length > 0) {
        for (let i = 0; i < valueSource.postfixes.length; i++) {
          value += this.getValueSourceValue(valueSource.postfixes[i], object)
        }
      }
      return value
    },
    getCharstCode(valueSource, data) {
      if (typeof valueSource === 'string') {
        return valueSource
      }
      let textCode = ''
      if (valueSource.codePrefixes && valueSource.codePrefixes.length > 0) {
        for (let m = 0; m < valueSource.codePrefixes.length; m++) {
          const codePrefix = valueSource.codePrefixes[m]
          textCode += this.getValueSourceValue(codePrefix, data)
        }
      }
      if (valueSource.type === 'static_value') {
        textCode += valueSource.staticValue
      } else if (valueSource.type === 'other_column') {
        const keys = valueSource.fieldName.split('.')
        let val = data
        for (let j = 0; j < keys.length; j++) {
          val = val[keys[j]]
          if (val === undefined) {
            return ''
          }
        }
        textCode += val
      }
      if (valueSource.codePostfixes && valueSource.codePostfixes.length > 0) {
        for (let m = 0; m < valueSource.codePostfixes.length; m++) {
          const codePostfix = valueSource.codePostfixes[m]
          textCode += this.getValueSourceValue(codePostfix, data)
        }
      }
      return textCode
    },
    isListVisibleColumn(column) {
      const visibleType = column.list.visibleType
      if (visibleType === 'none') {
        return false
      }
      if (visibleType === 'simple') {
        const visibleBy = column.list.visibleBy
        if (visibleBy) {
          for (let i = 0; i < visibleBy.length; i++) {
            if (visibleBy[i].type === 'master_data') {
              if (!this.masterSelectedRow) {
                return false
              }
              let key = visibleBy[i].fieldName + '_original_data'
              let val
              if (this.masterSelectedRow[key]) {
                val = this.masterSelectedRow[key]
              } else {
                key = visibleBy[i].fieldName
                val = this.masterSelectedRow[key]
              }
              for (let k = 0; k < visibleBy[i].in.length; k++) {
                if (val === visibleBy[i].in[k]) {
                  return true
                }
              }
              return false
            } else {
              console.error(
                'Unsupported visible-by type for list : ' + visibleBy[i].type
              )
              return false
            }
          }
        }
      }
      return true
    },
    isNotEmpty(obj) {
      return !this.isEmpty(obj)
    },
    isEmpty(obj) {
      return obj === undefined || obj === null || obj === ''
    },
    isAvailableRowAction(action) {
      if (this.rowActions) {
        return this.rowActions.indexOf(action) >= 0
      }
      return false
    },
    loadUpdate(userUpdate) {
      this.userUpdateRow = userUpdate.contents
      this.updateColumns = window.copyObject(userUpdate.columns)
      this.makeLabels(this.updateColumns)

      // 다국어 아직 로딩되지 않은 문자열은 store에 저장
      if (userUpdate && userUpdate.infos && userUpdate.infos.charsts) {
        for (let i = 0; i < userUpdate.infos.charsts.length; i++) {
          this.setI18nMessage(
            userUpdate.infos.charsts[i].locale.locale,
            userUpdate.infos.charsts[i].code,
            userUpdate.infos.charsts[i].charst
          )
        }
      }
      if (this.infos.additionalFieldInfoData) {
        this.initAdditionalFieldData(
          this.userUpdateRow,
          this.infos.additionalFieldInfoData
        )
      }
      if (this.infos.additionalFieldInfoSampleData) {
        this.initAdditionalFieldSampleData(
          this.userUpdateRow,
          this.infos.additionalFieldInfoSampleData
        )
      }
      this.userUpdateRow = this.updateUpdateColumns(
        this.userUpdateRow,
        this.updateColumns,
        userUpdate.infos
      )
      this.initialUpdateRow = window.copyObject(this.userUpdateRow)
    },
    initInsertRow(columns) {
      const row = {}
      for (let i = 0; i < columns.length; i++) {
        const key = columns[i].key
        const column = columns[i]
        if (!column.inputControl) {
          column.inputControl = {
            type: 'none'
          }
        }
        if (column.inputControl.type === 'i18n') {
          const charsts = []
          for (let i = 0; i < this.$store.state.locales.length; i++) {
            const locale = this.$store.state.locales[i]
            charsts.push({ charst: '', locale: { locale: locale.value } })
          }
          row[column.key] = charsts
        }
        if (column.inputControl.initialValue) {
          row[key] = column.inputControl.initialValue
        } else if (column.inputControl.type === 'select') {
          row[key] = ''
        }
        if (
          this.insertColumns[i].list &&
          this.insertColumns[i].list.treeNodeTitle
        ) {
          row[key] = 'common.text.new_item'
        }
        if (column.inputControl.type === 'section') {
          row[key] = []
          row[key].push(this.initInsertRow(column.columns))
        }
      }

      if (this.infos.additionalFieldInfo) {
        row.additionalFieldInfos = []
      }

      if (this.infos.additionalFieldInfoData) {
        this.initAdditionalFieldData(row, this.infos.additionalFieldInfoData)
      }
      if (this.infos.additionalFieldInfoSampleData) {
        this.initAdditionalFieldSampleData(
          row,
          this.infos.additionalFieldInfoSampleData
        )
      }

      if (this.slaveEvent) {
        for (let i = 0; i < this.totalColumns.length; i++) {
          const column = this.totalColumns[i]
          if (column.common && column.common.masterKey) {
            row[column.key] = this.masterSelectedRow
          }
        }
      }
      return row
    },
    updateUpdateColumns(row, columns, infos, isTree) {
      if (columns.length > 0) {
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i]
          if (!column.update) {
            columns.splice(i, 1)
            continue
          }
          const key = column.key
          if (!column.common || !column.common.label) {
            column.label = this.getDefaultColumnNameCode(key.toSnakeCase())
          } else {
            column.label = column.common.label
          }
          column.label = this.$t(column.label)
          const prefix = this.getPrefix(column.inputControl, row)
          if (prefix && row[key]) {
            row[key] = row[key].substring(prefix.length)
          }
          const postfix = this.getPostfix(column.inputControl, row)
          if (postfix && row[key]) {
            row[key] = row[key].substring(0, row[key].length - postfix.length)
          }
          if (
            column.inputControl &&
            column.inputControl.type === 'map' &&
            row[key]
          ) {
            row[key] = JSON.parse(row[key])
          } else if (
            column.inputControl &&
            column.inputControl.type === 'i18n'
          ) {
            const values = []
            if (isTree && this.isNewInserted(row)) {
              if (infos.charsts && infos.charsts[key]) {
                for (let j = 0; j < infos.charsts[key].length; j++) {
                  if (infos.charsts[key][j].code === row[key]) {
                    values.push(infos.charsts[key][j])
                  }
                }
              }
            } else {
              for (let k = 0; k < columns[i].common.textInfos.length; k++) {
                const textInfo = columns[i].common.textInfos[k]
                if (infos.charsts && infos.charsts[key]) {
                  for (let j = 0; j < infos.charsts[key].length; j++) {
                    let codePrefix = ''
                    if (
                      textInfo.codePrefixes &&
                      textInfo.codePrefixes.length > 0
                    ) {
                      for (let m = 0; m < textInfo.codePrefixes.length; m++) {
                        codePrefix += this.getValueSourceValue(
                          textInfo.codePrefixes[m],
                          row
                        )
                      }
                    }

                    const codeValue = row[textInfo.field]
                    let codePostfix = ''
                    if (
                      textInfo.codePostfixes &&
                      textInfo.codePostfixes.length > 0
                    ) {
                      for (let m = 0; m < textInfo.codePostfixes.length; m++) {
                        codePostfix += this.getValueSourceValue(
                          textInfo.codePostfixes[m],
                          row
                        )
                      }
                    }
                    if (
                      infos.charsts[key][j].code ===
                      codePrefix + codeValue + codePostfix
                    ) {
                      values.push(infos.charsts[key][j])
                    }
                  }
                }
              }
            }
            row[key] = values
          } else if (
            column.inputControl &&
            column.inputControl.type === 'multiselect_list'
          ) {
            const values = []
            if (column.inputControl.candidate) {
              const candidateKey = column.inputControl.candidate.key
              if (candidateKey) {
                for (let j = 0; j < row[key].length; j++) {
                  values.push(row[key][j][candidateKey])
                }
              }
            }
            row[key] = values
          } else if (
            column.inputControl &&
            column.inputControl.type === 'select'
          ) {
            if (!row[key]) {
              row[key] = ''
            } else if (
              column.inputControl.candidate &&
              column.inputControl.candidate.key &&
              typeof row[key] === 'object'
            ) {
              const candidateKey = column.inputControl.candidate.key
              if (candidateKey) {
                row[key] = row[key][candidateKey]
              }
            }
          } else if (
            column.inputControl &&
            column.inputControl.type === 'multiselect'
          ) {
            row[key] = this.convertToMultiselectValue(column, row, key)
          }

          if (
            columns[i].inputControl &&
            columns[i].inputControl.type === 'section'
          ) {
            if (column.type === 'Collection' || column.type === 'List') {
              if (!row[key]) {
                row[key] = [{}]
              }
              if (row[key].length === 0) {
                row[key].push(this.initInsertRow(column.columns))
              }
            } else if (!row[key]) {
              row[key] = this.initInsertRow(column.columns)
            }
          } else if (
            columns[i].inputControl &&
            columns[i].inputControl.type === 'section_list'
          ) {
            if (!row[key]) {
              row[key] = []
            }
          }
          if (columns[i].columns) {
            for (let j = 0; j < row[key].length; j++) {
              row[key][j] = this.updateUpdateColumns(
                row[key][j],
                columns[i].columns,
                infos
              )
            }
          }
        }
      }
      return row
    },
    convertToMultiselectValue(column, row, key) {
      const values = []
      if (column.inputControl.candidate) {
        const candidateKey = column.inputControl.candidate.key
        const candidateInfo = column.inputControl.candidate

        if (candidateKey) {
          if (Array.isArray(row[key])) {
            for (let j = 0; j < row[key].length; j++) {
              let value = row[key][j][candidateKey]

              let label = ''
              let optionData
              if (column.inputControl.candidate.options) {
                for (
                  let k = 0;
                  k < column.inputControl.candidate.options.length;
                  k++
                ) {
                  if (value === candidateInfo.options[k].value) {
                    label = this.makeOptionText(candidateInfo.options[k])
                    optionData = candidateInfo.options[k].data
                    break
                  }
                }
              } else {
                if (column.common && column.common.textInfos) {
                  label = this.getTextFromTextInfos(
                    column.common.textInfos,
                    row,
                    key,
                    column.common.separatorTextInfos,
                    column.common.targetType,
                    column.common.noDataLabelTextCode,
                    false,
                    value
                  ).stripTags()
                } else {
                  label = row[key][j]
                }

                optionData = row[key][j]
              }
              if (!value) {
                value = optionData
              }
              values.push({
                value: value,
                text: label,
                data: optionData
              })
            }
          } else if (row[key]) {
            let value = row[key][candidateKey]
            let label = ''
            let optionData
            if (column.inputControl.candidate.options) {
              for (
                let k = 0;
                k < column.inputControl.candidate.options.length;
                k++
              ) {
                if (value === candidateInfo.options[k].value) {
                  label = this.makeOptionText(candidateInfo.options[k])
                  optionData = candidateInfo.options[k].data
                  break
                }
              }
            } else {
              if (column.common && column.common.textInfos) {
                label = this.getTextFromTextInfos(
                  column.common.textInfos,
                  row,
                  key,
                  column.common.separatorTextInfos,
                  column.common.targetType,
                  column.common.noDataLabelTextCode
                ).stripTags()
              } else {
                label = row[key]
              }

              optionData = row[key]
            }
            if (!value) {
              value = optionData
            }
            values.push({
              value: value,
              text: label,
              data: optionData
            })
          }
        }
      }
      return values
    },
    getTextFromTextInfos(
      textInfos,
      item,
      key,
      separator,
      targetType,
      noDataLabelTextCode,
      inSection
    ) {
      let fieldValue

      if (inSection) {
        fieldValue = item
      } else if (textInfos[0].field) {
        fieldValue = item[textInfos[0].field]
      } else {
        fieldValue = item[key]
      }
      let text = ''
      if (Array.isArray(fieldValue)) {
        for (let i = 0; i < fieldValue.length; i++) {
          if (text) {
            text += ', '
          }
          text += this.getOneTextFromTextInfos(
            textInfos,
            fieldValue[i],
            item,
            separator,
            targetType,
            noDataLabelTextCode
          )
        }
      } else {
        text += this.getOneTextFromTextInfos(
          textInfos,
          fieldValue,
          item,
          separator,
          targetType,
          noDataLabelTextCode
        )
      }

      return text
    },
    getOneTextFromTextInfos(
      textInfos,
      item,
      parentItem,
      separator,
      targetType,
      noDataLabelTextCode
    ) {
      const texts = []
      for (let k = 0; k < textInfos.length; k++) {
        const textInfo = textInfos[k]

        let textTemp = ''
        let fieldValue = window.copyObject(item)

        const fieldInField = textInfo.fieldInField
        if (fieldInField) {
          const hierarchicalKeys = fieldInField.split('.')
          for (let m = 0; m < hierarchicalKeys.length; m++) {
            if (fieldValue) {
              fieldValue = fieldValue[hierarchicalKeys[m]]
            }
          }
        }

        if (fieldValue) {
          if (textInfo.textPrefixes && textInfo.textPrefixes.length > 0) {
            for (let m = 0; m < textInfo.textPrefixes.length; m++) {
              textTemp += textInfo.textPrefixes[m]
            }
          }

          let textCode = ''
          if (textInfo.codePrefixes && textInfo.codePrefixes.length > 0) {
            for (let m = 0; m < textInfo.codePrefixes.length; m++) {
              const codePrefix = textInfo.codePrefixes[m]
              textCode += this.getValueSourceValue(codePrefix, parentItem)
            }
          }
          textCode += fieldValue
          if (textInfo.codePostfixes && textInfo.codePostfixes.length > 0) {
            for (let m = 0; m < textInfo.codePostfixes.length; m++) {
              const codePostfix = textInfo.codePostfixes[m]
              textCode += this.getValueSourceValue(codePostfix, parentItem)
            }
          }
          if (textInfo.multilanguage) {
            textTemp += this.$t(textCode)
          } else {
            textTemp += textCode
          }

          if (textInfo.textPostfixes && textInfo.textPostfixes.length > 0) {
            for (let m = 0; m < textInfo.textPostfixes.length; m++) {
              textTemp += textInfo.textPostfixes[m]
            }
          }
          if (
            targetType === 'User' &&
            item &&
            item.sttusCode === 'user_status.secession' &&
            textInfos.length === k + 1
          ) {
            textTemp += ' - ' + this.$t('common.text.secession_user')
          }
        } else if (noDataLabelTextCode) {
          textTemp = this.$t(noDataLabelTextCode)
        } else if (targetType === 'User') {
          textTemp = this.$t('common.text.deleted_user')
        }
        texts.push(textTemp)
      }
      let text = ''
      for (const key in texts) {
        if (text) {
          text += separator
        }
        if (texts[key]) {
          text += texts[key].escapeHtml()
        }
      }
      return text
    },
    getContents(item, key) {
      let value = item

      if (key) {
        const keys = key.split('.')

        for (let i = 0; i < keys.length; i++) {
          if (value) {
            value = value[keys[i]]
          }
        }
      }
      return value
    },
    getNotifications(inputControl, created) {
      let notifications = inputControl.notifications
      if (!notifications) {
        notifications = []
      }
      if (created) {
        if (inputControl.insertNotifications) {
          notifications = notifications.concat(inputControl.insertNotifications)
        }
      } else if (inputControl.updateNotifications) {
        notifications = notifications.concat(inputControl.updateNotifications)
      }
      return notifications
    },
    isVisibleControl() {
      return this.isVisibleData(
        this.visibleData,
        this.visibleBy,
        this.visibleType
      )
    },
    isVisibleData(row, visibleBys, visibleType) {
      if (visibleType === 'simple') {
        if (visibleBys && row) {
          for (let i = 0; i < visibleBys.length; i++) {
            if (!this.isVisibleDatum(row, visibleBys[i])) {
              return false
            }
          }
          return true
        }
        return false
      }
      return true
    },
    isVisibleDatum(row, visibleBy) {
      if (visibleBy.type === 'master_data') {
        if (!this.masterSelectedRow) {
          return false
        }
        const key = visibleBy.fieldName
        const val = this.masterSelectedRow[key]
        for (let k = 0; k < visibleBy.in.length; k++) {
          if (val === visibleBy.in[k]) {
            return true
          }
        }
        return false
      } else if (visibleBy.type === 'depth') {
        if (visibleBy.depth && visibleBy.depth === this.nodeDepth) {
          return true
        }
        return false
      } else if (visibleBy.type === 'other_column') {
        // 다른 컬럼을 참조해서 보이기/안보이기 체크
        const keys = visibleBy.fieldName.split('.')
        let val = row
        val = val[keys[0]]

        if (val) {
          if (Array.isArray(val)) {
            if (keys.length > 1) {
              keys.splice(0, 1)
            }
            if (visibleBy.isEmpty) {
              if (val.length === 0) {
                return true
              } else {
                return false
              }
            }
            const options = window.copyObject(val)

            for (let j = 0; j < options.length; j++) {
              if (options[j].data) {
                val = options[j].data
              } else {
                val = options[j]
              }
              if (!val) {
                return false
              }
              for (let k = 0; k < keys.length; k++) {
                val = val[keys[k]]
                if (!val) {
                  return false
                }
              }
              for (let k = 0; k < visibleBy.in.length; k++) {
                if (val === visibleBy.in[k]) {
                  return true
                }
              }
              if (visibleBy.notIn && visibleBy.notIn.length > 0) {
                for (let k = 0; k < visibleBy.notIn.length; k++) {
                  if (val === visibleBy.notIn[k]) {
                    return false
                  }
                }
                return true
              }
            }
          } else {
            val = row
            for (let j = 0; j < keys.length; j++) {
              if (val) {
                val = val[keys[j]]
              }
              if (j === 0 && val.data) {
                val = val.data
              }
            }
            for (let j = 0; j < visibleBy.in.length; j++) {
              if (val === visibleBy.in[j]) {
                return true
              }
            }
            if (visibleBy.notIn && visibleBy.notIn.length > 0) {
              for (let j = 0; j < visibleBy.notIn.length; j++) {
                if (val === visibleBy.notIn[j]) {
                  return false
                }
              }
              return true
            }
          }
          return false
        } else if (visibleBy.isEmpty) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    getCssClasses(cssClassesObj, additionalClasses) {
      let classes = ''
      if (additionalClasses) {
        classes = additionalClasses
      }
      if (
        cssClassesObj &&
        cssClassesObj.cssClasses &&
        cssClassesObj.cssClasses.length > 0
      ) {
        for (let i = 0; i < cssClassesObj.cssClasses.length; i++) {
          if (classes) {
            classes += ' '
          }
          classes += cssClassesObj.cssClasses[i]
        }
      }
      return classes
    },
    emitForceUpdate() {
      this.$emit('forceUpdate')
    },
    onForceUpdate() {
      this.$forceUpdate()
      if (this.$refs) {
        for (const key in this.$refs) {
          if (Array.isArray(this.$refs[key]) && this.$refs[key].length > 0) {
            for (let i = 0; i < this.$refs[key].length; i++) {
              if (
                this.$refs[key] &&
                this.$refs[key][i] &&
                this.$refs[key][i].onForceUpdate
              ) {
                this.$refs[key][i].onForceUpdate()
              } else if (
                this.$refs[key] &&
                this.$refs[key][i] &&
                this.$refs[key][i].$forceUpdate
              ) {
                this.$refs[key][i].$forceUpdate()
              }
            }
          } else if (!Array.isArray(this.$refs[key])) {
            if (this.$refs[key] && this.$refs[key].onForceUpdate) {
              this.$refs[key].onForceUpdate()
            } else if (this.$refs[key] && this.$refs[key].$forceUpdate) {
              this.$refs[key].$forceUpdate()
            }
          }
        }
      }
    },
    initAdditionalFieldData(row, additionalFieldInfoData) {
      if (!row.additionalFieldData) {
        row.additionalFieldData = {}
      }
      const infoData = row.additionalFieldData
      for (
        let i = 0;
        i < additionalFieldInfoData.additionalFieldInfos.length;
        i++
      ) {
        const info = additionalFieldInfoData.additionalFieldInfos[i]
        const ownerModel = info.ownerModel
        if (!infoData[ownerModel]) {
          infoData[ownerModel] = {}
        }
      }
    },
    initAdditionalFieldSampleData(row, additionalFieldInfoSampleData) {
      if (!row.additionalFieldData) {
        row.additionalFieldData = {}
      }
      const infoData = row.additionalFieldData
      for (
        let i = 0;
        i < additionalFieldInfoSampleData.additionalFieldInfos.length;
        i++
      ) {
        const info = additionalFieldInfoSampleData.additionalFieldInfos[i]
        const ownerModel = info.ownerModel
        if (!infoData[ownerModel]) {
          infoData[ownerModel] = {}
        }
      }
    },
    isImagePurpose(purpose) {
      return (
        purpose.endsWith('front') ||
        purpose.endsWith('side') ||
        purpose === 'file_purpose.thumb' ||
        purpose === 'file_purpose.image' ||
        purpose === 'file_purpose.background_image' ||
        purpose.startsWith('file_purpose.image_') ||
        purpose.endsWith('_image')
      )
    },
    makeOptionText(option) {
      let text = ''
      if (!option.texts || option.texts.length === 0) {
        return option.value
      }
      for (let i = 0; i < option.texts.length; i++) {
        if (text) {
          text += ' - '
        }
        let textItem = ''
        if (
          option.texts[i].textPrefixes &&
          option.texts[i].textPrefixes.length > 0
        ) {
          for (let j = 0; j < option.texts[i].textPrefixes.length; j++) {
            textItem += option.texts[i].textPrefixes[j]
          }
        }
        if (option.texts[i].multilanguage) {
          let code = ''
          if (
            option.texts[i].codePrefixes &&
            option.texts[i].codePrefixes.length > 0
          ) {
            for (let j = 0; j < option.texts[i].codePrefixes.length; j++) {
              const codePrefix = option.texts[i].codePrefixes[j]
              if (codePrefix.type === 'static_value') {
                code += codePrefix.staticValue
              } else if (codePrefix.type === 'other_column') {
                if (codePrefix.fieldName) {
                  const fields = codePrefix.fieldName.split('.')
                  let val = option.data
                  for (let k = 0; k < fields.length; k++) {
                    val = val[fields[k]]
                  }
                  code += val
                }
              }
            }
          }
          code += option.texts[i].value
          if (
            option.texts[i].codePostfixes &&
            option.texts[i].codePostfixes.length > 0
          ) {
            for (let j = 0; j < option.texts[i].codePostfixes.length; j++) {
              const codePostfix = option.texts[i].codePostfixes[j]
              if (codePostfix.type === 'static_value') {
                code += codePostfix.staticValue
              } else if (codePostfix.type === 'other_column') {
                if (codePostfix.fieldName) {
                  const fields = codePostfix.fieldName.split('.')
                  let val = option.data
                  for (let k = 0; k < fields.length; k++) {
                    val = val[fields[k]]
                  }
                  code += val
                }
              }
            }
          }
          textItem += this.$t(code)
        } else {
          textItem += option.texts[i].value
        }
        if (
          option.texts[i].textPostfixes &&
          option.texts[i].textPostfixes.length > 0
        ) {
          for (let j = 0; j < option.texts[i].textPostfixes.length; j++) {
            textItem += option.texts[i].textPostfixes[j]
          }
        }
        text += textItem
      }
      return text
    },
    getDefaultColumnNameCode(key) {
      let code = 'column.nm.'
      if (key.indexOf('.') > 0) {
        code += key.substring(key.indexOf('.') + 1)
      } else {
        code += key
      }
      return code
    },
    makeLabels(columns) {
      if (!columns) {
        return
      }

      for (let i = 0; i < columns.length; i++) {
        const column = columns[i]
        if (!column.common || !column.common.label) {
          column.label = this.getDefaultColumnNameCode(column.key.toSnakeCase())
        } else {
          column.label = column.common.label
        }
        column.label = this.$t(column.label)
        if (
          column.inputControl &&
          (column.inputControl.type === 'section' ||
            column.inputControl.type === 'section_list')
        ) {
          this.makeLabels(column.columns)
        }
      }
    },
    openMenu(menu) {
      this.$emit('open-menu', menu)
    },
    closeMenu() {
      this.$forceUpdate()
      this.$emit('close-menu')
    },
    openMenuByAlias(alias) {
      const menu = this.findMenuByAlias(alias)
      this.$eventHub.$emit('open-menu', menu)
    },
    findMenuByAlias(alias, menus) {
      if (!menus) {
        menus = this.menus
      }
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].menu === alias) {
          return menus[i]
        }
        if (menus[i].children && menus[i].children.length > 0) {
          const foundMenu = this.findMenuByAlias(alias, menus[i].children)
          if (foundMenu) {
            return foundMenu
          }
        }
      }
    },
    getMenusByRootMenu(rootMenu, paramMenus) {
      let menus = paramMenus
      if (!menus) {
        menus = this.menus
      }
      let retMenus
      if (menus && menus.length > 0) {
        for (let i = 0; i < menus.length; i++) {
          const menu = menus[i]
          if (menu.menu === rootMenu) {
            return menu.children
          }
          if (menu.children) {
            retMenus = this.getMenusByRootMenu(rootMenu, menu.children)
            if (retMenus) {
              return retMenus
            }
          }
        }
      }
      // 반환된 것도 없고 재귀호출이 되지 않은 상태이면 [] 반환
      if (!retMenus && !paramMenus) {
        retMenus = []
      }
      return retMenus
    },
    getMenusByLocation(lc) {
      const menus = []
      if (this.menus && this.menus.length > 0) {
        for (let i = 0; i < this.menus.length; i++) {
          if (
            this.menus[i].menuDsplyLcs &&
            this.menus[i].menuDsplyLcs.length > 0
          ) {
            for (let j = 0; j < this.menus[i].menuDsplyLcs.length; j++) {
              const menuDsplyLc = this.menus[i].menuDsplyLcs[j].menuLcCode
              if (lc === menuDsplyLc) {
                if (this.menus[i].link) {
                  if (this.loggedInUser) {
                    if (
                      this.menus[i].link === '/login' ||
                      this.menus[i].link === 'login'
                    ) {
                      menus.push({
                        link: '/logout',
                        menu: 'logout',
                        sttusCode: 'menu_status.active'
                      })
                      continue
                    }
                  }
                }
                menus.push(this.menus[i])
              }
            }
          }
        }
      }
      return menus
    },
    getValueKey(column) {
      if (
        !column ||
        !column.inputControl ||
        !column.inputControl.candidate ||
        !column.inputControl.candidate.key
      ) {
        return 'id'
      }
      return column.inputControl.candidate.key
    },
    getSelectOptions(column) {
      if (
        !column ||
        !column.inputControl ||
        !column.inputControl.candidate ||
        !column.inputControl.candidate.options
      ) {
        return []
      }
      const options = []
      if (column.inputControl.type === 'select') {
        options.push({
          value: '',
          text:
            this.$t('column.nm.' + column.key.toSnakeCase()) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      const conditions = column.inputControl.candidate.conditions
      for (let i = 0; i < column.inputControl.candidate.options.length; i++) {
        const optionData = column.inputControl.candidate.options[i].data
        let add = true
        for (let j = 0; j < conditions.length; j++) {
          const condition = conditions[j]
          if (condition.type === 'master_data') {
            add = false
            if (
              condition.targetOperator === 'equals' &&
              this.masterSelectedRow[condition.targetFieldName] ===
                condition.targetValue
            ) {
              if (
                condition.candidateOperator === 'equals' &&
                optionData[condition.candidateFieldName] ===
                  condition.candidateValue
              ) {
                add = true
              } else if (
                condition.candidateOperator === 'not_equals' &&
                optionData[condition.candidateFieldName] !==
                  condition.candidateValue
              ) {
                add = true
              }
            } else if (
              condition.targetOperator === 'not_equals' &&
              this.masterSelectedRow[condition.targetFieldName] !==
                condition.targetValue
            ) {
              if (
                condition.candidateOperator === 'equals' &&
                optionData[condition.candidateFieldName] ===
                  condition.candidateValue
              ) {
                add = true
              } else if (
                condition.candidateOperator === 'not_equals' &&
                optionData[condition.candidateFieldName] !==
                  condition.candidateValue
              ) {
                add = true
              }
            }
            if (add) break
          }
        }

        if (!add) {
          continue
        }
        const text = this.makeOptionText(
          column.inputControl.candidate.options[i]
        )
        const value = column.inputControl.candidate.options[i].value

        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    },
    getSelectOptionsFromRawOptions: function(key, rawOptions, type) {
      if (!rawOptions) {
        return []
      }
      const options = []
      if (type === 'select') {
        options.push({
          value: '',
          text:
            this.$t('column.nm.' + key.toSnakeCase()) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      for (let i = 0; i < rawOptions.length; i++) {
        const optionData = rawOptions[i].data
        const text = this.makeOptionText(rawOptions[i])
        const value = rawOptions[i].value

        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    },
    async getCodes(codeGroupId) {
      const res = await this.$axios.$get(
        '/code/public/codes?codeGroup=' + codeGroupId,
        {
          no_loading: true
        }
      )
      return res.data
    },
    async getCodeOptions(codeGroupId) {
      const options = []
      const codes = await this.getCodes(codeGroupId)
      options.push({ text: this.$t('code_group.nm.' + codeGroupId), value: '' })
      for (const key in codes) {
        const code = codes[key]
        options.push({
          text: this.$t('code.nm.' + code.codeId),
          value: code.codeId
        })
      }
      return options
    },
    async getCharstsByPrefix(prefix) {
      const res = await this.$axios.$get(
        '/i18n/manage/loadStringsByPrefix?prefix=' + encodeURIComponent(prefix),
        {
          no_loading: true
        }
      )
      return res.data
    },
    getSearchSelectOptions: function(column) {
      if (column.key && column.key.endsWith('Flag')) {
        return [
          {
            value: '',
            text: this.$t('column.nm.' + column.key.toSnakeCase())
          },
          {
            value: 'Y',
            text: 'Y'
          },
          {
            value: 'N',
            text: 'N'
          }
        ]
      }
      if (
        !column.search ||
        !column.search.candidate ||
        !column.search.candidate.options
      ) {
        return []
      }
      const options = []
      if (column.search.type === 'select') {
        options.push({
          value: '',
          text:
            this.$t(this.getDefaultColumnNameCode(column.key.toSnakeCase())) +
            ' - ' +
            this.$t('common.placeholder.select'),
          data: undefined
        })
      }
      for (let i = 0; i < column.search.candidate.options.length; i++) {
        const text = this.makeOptionText(column.search.candidate.options[i])
        const value = column.search.candidate.options[i].value
        const optionData = column.search.candidate.options[i].data
        options.push({
          value: value,
          text: text,
          data: optionData
        })
      }
      return options
    }
  }
})
